import React from 'react'

const AltriRami = () => {
  return (
    <div>
      Altri Rami
    </div>
  )
}

export default AltriRami
